import { Injectable, PipeTransform, Pipe, Input } from '@angular/core';

@Pipe({
  name: 'thaidate'
})
export class ThaiDatePipe implements PipeTransform {
  transform(date: string, format: string): string {
    const ThaiDay = ['อาทิตย์', 'จันทร์', 'อังคาร', 'พุธ', 'พฤหัสบดี', 'ศุกร์', 'เสาร์'];
    const shortThaiMonth = [
      'ม.ค.', 'ก.พ.', 'มี.ค.', 'เม.ย.', 'พ.ค.', 'มิ.ย.',
      'ก.ค.', 'ส.ค.', 'ก.ย.', 'ต.ค.', 'พ.ย.', 'ธ.ค.'
    ];
    const longThaiMonth = [
      'มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน',
      'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม'
    ];

    const MonthNumber = [
      '01', '02', '03', '04', '05', '06',
      '07', '08', '09', '10', '11', '12'
    ];
    const inputDate = new Date(date);
    const dataDate = [
      inputDate.getDay(),
      inputDate.getDate(),
      inputDate.getMonth(),
      inputDate.getFullYear(),
      inputDate.getHours(),
      inputDate.getMinutes(),
      inputDate.getSeconds()
    ];
    const outputDateFull = [
      'วัน ' + ThaiDay[dataDate[0]],
      'ที่ ' + dataDate[1],
      'เดือน ' + longThaiMonth[dataDate[2]],
      'พ.ศ. ' + (dataDate[3] + 543)
    ];

    const outputDate = [
      'วันที่ ' + dataDate[1],
      ' ' + longThaiMonth[dataDate[2]],
      'พ.ศ. ' + (dataDate[3] + 543)
    ];

    const outputDateShort = [
      dataDate[1],
      shortThaiMonth[dataDate[2]],
      dataDate[3] + 543
    ];
    const outputDateMedium = [
      dataDate[1],
      longThaiMonth[dataDate[2]],
      dataDate[3] + 543
    ];

    // Number Short Time
    const outputDateNumberShortTime = [
      (inputDate.getDate() < 10 ? '0' : '') + dataDate[1] +
      '/' + MonthNumber[dataDate[2]] +
      '/' + (dataDate[3] + 543),
      (inputDate.getHours() < 10 ? '0' : '') + dataDate[4] +
      ':' + (inputDate.getMinutes() < 10 ? '0' : '') + dataDate[5] +
      ':' + (inputDate.getSeconds() < 10 ? '0' : '') + dataDate[6]
    ];
    // Number Short
    const outputDateNumberShort = [
      (inputDate.getDate() < 10 ? '0' : '') + dataDate[1] +
      '/' + MonthNumber[dataDate[2]] +
      '/' + (dataDate[3] + 543)
    ];


    // Number Short EXP:01012563
    const outputDateNumberShortFileExcel = [
      (inputDate.getDate() < 10 ? '0' : '') + dataDate[1] + MonthNumber[dataDate[2]] + (dataDate[3] + 543)
    ];

    // Output time hh:mm
    const outputDateTimeShort = [
      dataDate[1],
      shortThaiMonth[dataDate[2]],
      dataDate[3] + 543,
      (inputDate.getHours() < 10 ? '0' : '') + dataDate[4] +
      ':' + (inputDate.getMinutes() < 10 ? '0' : '') + dataDate[5]
    ];

    let returnDate: string;
    returnDate = outputDateMedium.join(' ');
    if (format === 'full') {
      returnDate = outputDateFull.join(' ');
    }
    if (format === 'date') {
      // วัน/เดือน/ปี
      returnDate = outputDate.join(' ');
    }
    if (format === 'medium') {
      returnDate = outputDateMedium.join(' ');
    }
    if (format === 'short') {
      returnDate = outputDateShort.join(' ');
    }
    if (format === 'number-short-time') {
      returnDate = outputDateNumberShortTime.join(' ');
    }
    if (format === 'number-short') {
      returnDate = outputDateNumberShort.join(' ');
    }
    if (format === 'mini-short') {
      returnDate = outputDateNumberShortFileExcel.join(' ');
    }
    if (format === 'date-time') {
      returnDate = outputDateTimeShort.join(' ');
    }
    return returnDate;
  }
}
